/* global axios */
import ApiClient from './ApiClient';

class TranslationsAPI extends ApiClient {
  constructor() {
    super('translations', { accountScoped: true });
  }

  translate(text, targetLanguage) {
    return axios.post(this.url, {
      text,
      target_language: targetLanguage,
    });
  }
}

export default new TranslationsAPI();
